// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9bdc84a9","455":"412ca0b4","977":"6d1fc123"}[chunkId] + ".chunk.js";
};